// The mailing lists and privacy of an account, as the fullstack's base-layer/shared/users/
// subscriptions.js and privacy.js (CLERK.md § Subscriptions, § Privacy; 2026-10-21):
// publicMetadata.subscriptions, the lists chosen (an array, [] = none) or an open invitation
// ({invited: …}: none yet); and publicMetadata.privacy (the earlier allowsContact).

export const SUBSCRIPTION_LISTS = ["workshop", "masterclass", "showcase"];

const getKnownLists = (lists) => SUBSCRIPTION_LISTS.filter((list) => lists.includes(list));

export function getSubscribedTo(publicMetadata) {
  const {subscriptions} = publicMetadata || {};
  return Array.isArray(subscriptions) ? getKnownLists(subscriptions) : [];
}

// subscribed to at least one list
export const getIsSubscribed = (publicMetadata) => getSubscribedTo(publicMetadata).length > 0;

export function getPrivacy(publicMetadata) {
  const {privacy, allowsContact} = publicMetadata || {};
  const saved = privacy && typeof privacy === "object" ? privacy : {};
  return {
    makeMyProfilePublic: saved.makeMyProfilePublic === true,
    letOthersContactMe: (saved.letOthersContactMe ?? allowsContact) !== false,
  };
}
